import styled from 'styled-components';

export const Contant = styled.div`
    h2 {
        color: var(--color-white);
        text-decoration: none;
        font-weight: 700;
    }
`;
